import React, { useEffect } from 'react'
import {
  TheContent,
  TheSidebar,
  TheFooter,
  TheHeader
} from './index'
import cookie from 'react-cookies'
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import InActiveMsg from './InActiveMsg'

const TheLayout = () => {
  const history = useHistory();

  useEffect(() => {
    if (!cookie.load("GST_USER_DATA")) {
      history.push("/login")
    } else {
      if (!cookie.load("SELECTED_GSTIN_DETAIL")) {
        history.push("/no-gst")
      }
    }

  }, []);


  if (cookie.load("SELECTED_GSTIN_DETAIL")) {
    return (
      <div className="c-app c-default-layout" >

        {/* <TheSidebar/> */}
        <div className="c-wrapper">
          <TheHeader />
          <InActiveMsg />
          <div className="c-body">
            <TheContent />
          </div>
          {/* <TheFooter/> */}
        </div>
      </div>
    )
  } else {
    return <></>
  }
}

export default TheLayout
